import React from 'react';
import { LeafIcon } from 'lucide-react';
type SiteFooterProps = {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
};
export function SiteFooter({
  onOpenPrivacy,
  onOpenTerms
}: SiteFooterProps) {
  const year = new Date().getFullYear();
  return <footer className="border-t border-neutral-800 bg-[#14161a] text-neutral-400" data-id="element-173" data-mp="3mfg9emvczp5e">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6" data-id="element-174" data-mp="3hhwstgb6v0aa">
        <div className="flex items-center gap-2.5" data-id="element-175" data-mp="3dh4mautpb9hp">
          <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-brand text-white" data-id="element-176" data-mp="3dervds5ytosi">
            <LeafIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="38juksgt1f7di" />
          </span>
          <span className="font-serif text-lg font-bold text-white" data-id="element-178" data-mp="33j6vq0odd0lx">
            NutriNatural Info
          </span>
        </div>

        <div className="mt-8 space-y-4 font-sans text-[0.8rem] leading-relaxed text-neutral-400" data-id="element-179" data-mp="2ylyb7tfr0khi">
          <p data-id="element-180" data-mp="11oxufrq7cc3j">
            Descargo de Responsabilidad de Salud y Resultados (Health &amp; Earnings Disclaimer):
            «La información, protocolos y recomendaciones presentados en el Método Glucosa
            Estable tienen fines exclusivamente educativos e informativos. Este sitio no tiene la
            intención de proporcionar asesoramiento médico, ni de diagnosticar, tratar, curar o
            prevenir ninguna condición de salud o enfermedad (incluyendo, pero no limitado a, la
            diabetes tipo 1, tipo 2 o resistencia a la insulina). El contenido de este programa
            no sustituye la consulta con un profesional de la salud calificado. Siempre consulte
            a su médico antes de realizar cualquier cambio en su dieta, rutina de ejercicios o
            estilo de vida.
          </p>
          <p data-id="element-181" data-mp="1jq4n7w9sr7hl">
            Los testimonios y casos de éxito presentados en este sitio son experiencias reales de
            usuarios que han aplicado el método, sin embargo, se presentan con fines
            ilustrativos. Los resultados metabólicos y de pérdida de peso varían de persona a
            persona en función de la genética, el punto de partida físico, la edad y el nivel de
            compromiso individual con el protocolo. Ninguna información en este sitio constituye
            una garantía o promesa de resultados específicos.»
          </p>
          <p data-id="element-182" data-mp="2d4c9qfvbsfgu">
            Descargo de Responsabilidad de Plataformas (Social Media Disclaimer): «Este sitio web
            no forma parte del sitio web de Facebook™ o Facebook Inc. Además, este sitio NO está
            respaldado, patrocinado ni administrado de ninguna manera por Facebook™, Meta
            Platforms, Inc., TikTok™ o ByteDance Ltd. FACEBOOK™ y TIKTOK™ son marcas comerciales
            registradas de sus respectivos propietarios. El acceso y uso de este sitio están
            sujetos a nuestras propias políticas de privacidad y términos de servicio, los cuales
            son independientes de las plataformas de redes sociales mencionadas.»
          </p>
          <p data-id="element-183" data-mp="1ff98dkywu4hm">
            Advertorial Disclosure (Transparencia Publicitaria): «AVISO IMPORTANTE: Este sitio web
            es un publirreportaje (Advertorial). La historia y los personajes descritos en este
            artículo son una representación creativa basada en hechos y datos científicos para
            ilustrar los beneficios potenciales de la secuenciación de alimentos. La información
            proporcionada es un anuncio y no una noticia de prensa real, blog informativo o
            actualización oficial de salud pública. Al hacer clic en los enlaces de esta página,
            el usuario podrá ser redirigido a una página de ventas donde se ofrece un producto
            digital de pago.»
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-neutral-800 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-184" data-mp="3m2hq00dvutan">
          <p className="font-sans text-xs text-neutral-500" data-id="element-185" data-mp="2pjsdr5qs238j">
            © {year} NutriNatural Info. Todos los derechos reservados.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-186" data-mp="2tk2m2p21l5qk">
            <button type="button" onClick={onOpenPrivacy} className="font-sans text-xs font-medium text-neutral-300 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-white" data-id="element-187" data-mp="2aiby2j71kfm2">
              Política de Privacidad
            </button>
            <button type="button" onClick={onOpenTerms} className="font-sans text-xs font-medium text-neutral-300 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-white" data-id="element-188" data-mp="2fetxr4nilnrj">
              Términos de Uso
            </button>
          </nav>
        </div>
      </div>
    </footer>;
}